module.exports = __webpack_public_path__ + "c0460c6a47cb2629baba6c080c327bab.pdf";